// extracted by mini-css-extract-plugin
export default {"ImageX":"z4Uj6S","imageX":"z4Uj6S","responsiveImg":"dEA8pt","linkWithEffect":"ECDI2e","imageLink":"cn98vh"};